import { ANNOUNCEMENT_MODE, ANNOUNCEMENT_ERROR } from 'containers/ClanLanding/components/AnnouncementsCard/constants'

import {
    NOTIFICATION_MESSAGE_KEY as NOTIFICATION_TYPE,
    displayErrorNotification,
    displayInfoNotification,
} from './notification'

import { handleErrors } from './errors'

import * as api from './api'

export const ANNOUNCEMENTS_CHANGE_MODE = 'announcements/CHANGE_MODE'
export const ANNOUNCEMENTS_OPENED_ID = 'announcements/OPENED_ID'

export const ANNOUNCEMENTS_REQUEST = 'announcements/REQUEST'
export const ANNOUNCEMENTS_SUCCESS = 'announcements/SUCCESS'
export const ANNOUNCEMENTS_ERROR = 'announcements/ERROR'

export const ANNOUNCEMENTS_LIST = 'announcements/LIST'
export const ANNOUNCEMENTS_SETTINGS = 'announcements/SETTINGS'
export const ANNOUNCEMENTS_CLEAR_DATA = 'announcements/CLEAR_DATA'

export const changeOpenedAnnouncement = (announcementId = null) => {
    return async (dispatch) => {
        dispatch({
            type: ANNOUNCEMENTS_OPENED_ID,
            payload: announcementId,
        })
    }
}

export const switchToEditorMode = (mode) => {
    return async (dispatch, getState) => {
        dispatch({ type: ANNOUNCEMENTS_REQUEST })

        const { settings, clan, announcements } = getState()
        const host = settings.gatewayHost
        const clanId = clan.id

        try {
            const [list, settings] = await api.requestAnnouncements(host, clanId)

            const hasPermissions = settings.can_create_messages
            const isLimitReached = settings.is_limit_reached
            const hasAnnouncement = list
                .find(item => item.message_id === announcements.openedAnnouncement)

            if (!hasPermissions) {
                displayErrorNotification(NOTIFICATION_TYPE.NO_PERMISSION)
            } else if (mode === ANNOUNCEMENT_MODE.CREATE && isLimitReached) {
                displayErrorNotification(NOTIFICATION_TYPE.LIMIT_REACHED)
            } else if (mode === ANNOUNCEMENT_MODE.EDIT && !hasAnnouncement) {
                displayErrorNotification(NOTIFICATION_TYPE.NOT_EXIST)

                dispatch({
                    type: ANNOUNCEMENTS_CHANGE_MODE,
                    payload: ANNOUNCEMENT_MODE.CARD,
                })
            } else {
                dispatch({ type: ANNOUNCEMENTS_CHANGE_MODE, payload: mode })
            }

            dispatch({ type: ANNOUNCEMENTS_LIST, payload: list })
            dispatch({ type: ANNOUNCEMENTS_SETTINGS, payload: settings })
            dispatch({ type: ANNOUNCEMENTS_SUCCESS })
        } catch (error) {
            const announcementError = mode === ANNOUNCEMENT_MODE.EDIT ?
                ANNOUNCEMENT_ERROR.EDIT :
                ANNOUNCEMENT_ERROR.CREATE

            dispatch(handleErrors(announcementError, error))
        }
    }
}

export const changeMode = (mode) => {
    return async (dispatch) => {
        if (mode === ANNOUNCEMENT_MODE.CREATE || mode === ANNOUNCEMENT_MODE.EDIT) {
            dispatch(switchToEditorMode(mode))
        } else {
            dispatch({ type: ANNOUNCEMENTS_CHANGE_MODE, payload: mode })
        }
    }
}

export const requestAnnouncements = () => {
    return async (dispatch, getState) => {
        dispatch({ type: ANNOUNCEMENTS_REQUEST })

        const { settings, clan } = getState()
        const host = settings.gatewayHost
        const clanId = clan.id

        try {
            const [list, settings] = await api.requestAnnouncements(host, clanId)

            dispatch({ type: ANNOUNCEMENTS_LIST, payload: list })
            dispatch({ type: ANNOUNCEMENTS_SETTINGS, payload: settings })
            dispatch({ type: ANNOUNCEMENTS_SUCCESS })
        } catch (error) {
            dispatch(handleErrors(null, error))
            dispatch({ type: ANNOUNCEMENTS_CLEAR_DATA })
        }
    }
}

export const createAnnouncement = ({ message, expiredAt, groupType }) => {
    return async (dispatch, getState) => {
        dispatch({ type: ANNOUNCEMENTS_REQUEST })

        const { settings, clan } = getState()
        const host = settings.gatewayHost
        const clanId = clan.id

        const body = {
            message: message,
            expired_at: expiredAt,
            group: groupType,
        }

        try {
            const response = await api.createAnnouncement(host, body)
            const [list, settings] = await api.requestAnnouncements(host, clanId)

            dispatch({ type: ANNOUNCEMENTS_LIST, payload: list })
            dispatch({ type: ANNOUNCEMENTS_SETTINGS, payload: settings })

            dispatch(changeOpenedAnnouncement(Number(response.message_id)))
            dispatch(changeMode(ANNOUNCEMENT_MODE.VIEW))

            displayInfoNotification(NOTIFICATION_TYPE.EDITED)
            dispatch({ type: ANNOUNCEMENTS_SUCCESS })
        } catch (error) {
            dispatch(handleErrors(ANNOUNCEMENT_ERROR.CREATE, error))
        }
    }
}

export const updateAnnouncement = ({ messageId, message, expiredAt, groupType }) => {
    return async (dispatch, getState) => {
        dispatch({ type: ANNOUNCEMENTS_REQUEST })

        const { settings, clan } = getState()
        const host = settings.gatewayHost
        const clanId = clan.id

        const body = {
            message_id: messageId,
            message: message,
            expired_at: expiredAt,
            group: groupType,
        }

        try {
            const response = await api.editAnnouncement(host, body)
            const [list, settings] = await api.requestAnnouncements(host, clanId)

            dispatch({ type: ANNOUNCEMENTS_LIST, payload: list })
            dispatch({ type: ANNOUNCEMENTS_SETTINGS, payload: settings })

            dispatch(changeOpenedAnnouncement(Number(response.message_id)))
            dispatch(changeMode(ANNOUNCEMENT_MODE.VIEW))

            displayInfoNotification(NOTIFICATION_TYPE.EDITED)
            dispatch({ type: ANNOUNCEMENTS_SUCCESS })
        } catch (error) {
            dispatch(handleErrors(ANNOUNCEMENT_ERROR.EDIT, error, messageId))
        }
    }
}

export const archiveAnnouncement = (messageId) => {
    return async (dispatch, getState) => {
        dispatch({ type: ANNOUNCEMENTS_REQUEST })

        const { settings, clan } = getState()
        const host = settings.gatewayHost
        const clanId = clan.id
        const body = { message_id: messageId }

        try {
            await api.archiveAnnouncement(host, body)
            const [list, settings] = await api.requestAnnouncements(host, clanId)

            dispatch({ type: ANNOUNCEMENTS_LIST, payload: list })
            dispatch({ type: ANNOUNCEMENTS_SETTINGS, payload: settings })

            dispatch(changeMode(ANNOUNCEMENT_MODE.CARD))

            displayInfoNotification(NOTIFICATION_TYPE.ARCHIVED)
            dispatch({ type: ANNOUNCEMENTS_SUCCESS })
        } catch (error) {
            dispatch(handleErrors(ANNOUNCEMENT_ERROR.ARCHIVE, error, messageId))
        }
    }
}

export const deleteAnnouncement = (messageId) => {
    return async (dispatch, getState) => {
        dispatch({ type: ANNOUNCEMENTS_REQUEST })

        const { settings, clan } = getState()
        const host = settings.gatewayHost
        const clanId = clan.id
        const body = { message_id: messageId }

        try {
            await api.deleteAnnouncement(host, body)
            const [list, settings] = await api.requestAnnouncements(host, clanId)

            dispatch({ type: ANNOUNCEMENTS_LIST, payload: list })
            dispatch({ type: ANNOUNCEMENTS_SETTINGS, payload: settings })

            dispatch(changeMode(ANNOUNCEMENT_MODE.CARD))

            displayInfoNotification(NOTIFICATION_TYPE.DELETED)
            dispatch({ type: ANNOUNCEMENTS_SUCCESS })
        } catch (error) {
            dispatch(handleErrors(ANNOUNCEMENT_ERROR.DELETE, error, messageId))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/announcements/index.js